import React from 'react';
import MainTemplate from './components/templates/MainTemplate';

const App: React.FC = () => {
  return <MainTemplate />;
};

export default App;
